import { FunctionComponent, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends PropsWithChildren {
  type: 'white' | 'blue' | 'orange';
  className?: string;
}

const InfoChit: FunctionComponent<Props> = ({ children, type, className }) => {
  let classNameToUse = twMerge('py-1 px-2 border rounded-md font-semibold leading-tight', className);

  switch (type) {
    case 'blue':
      classNameToUse = twMerge(classNameToUse, 'bg-primary-700 font-medium border-primary-700 text-white');
      break;
    case 'orange':
      classNameToUse = twMerge(classNameToUse, 'bg-secondary-600 font-medium border-secondary-600 text-white');
      break;
    case 'white':
      classNameToUse = twMerge(classNameToUse, 'bg-white border-primary-std text-primary-std ');
      break;
  }

  return <div className={classNameToUse}>{children}</div>;
};

export default InfoChit;
